import { render, staticRenderFns } from "./kiosk-certified-main.vue?vue&type=template&id=1789c44b&"
import script from "./kiosk-certified-main.vue?vue&type=script&lang=js&"
export * from "./kiosk-certified-main.vue?vue&type=script&lang=js&"
import style0 from "./kiosk-certified-main.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports